import React, { createContext, useState, useContext, useCallback } from 'react';

var AuthContext = createContext(null);

export function AuthProvider({ children }) {
  var userState = useState(null);
  var user = userState[0];
  var setUser = userState[1];
  var tokenState = useState(null);
  var token = tokenState[0];
  var setToken = tokenState[1];
  var loadState = useState(false);
  var loading = loadState[0];
  var setLoading = loadState[1];

  var login = useCallback(async function(email, password) {
    setLoading(true);
    try {
      var mockUser = {
        id: '1',
        name: 'Jackie Crowley',
        email: email,
        username: 'jackie_c_recovery',
        streak: 1,
        nextMilestone: 13,
      };
      setToken('mock-jwt-token');
      setUser(mockUser);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  var signup = useCallback(async function(email, password) {
    setLoading(true);
    try {
      var mockUser = {
        id: '2',
        name: 'New User',
        email: email,
        username: '',
        streak: 0,
        nextMilestone: 14,
      };
      setToken('mock-jwt-token');
      setUser(mockUser);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  var logout = useCallback(function() {
    setToken(null);
    setUser(null);
  }, []);

  var restoreSession = useCallback(function() {}, []);

  return (
    <AuthContext.Provider value={{
      user: user,
      token: token,
      loading: loading,
      login: login,
      signup: signup,
      logout: logout,
      restoreSession: restoreSession,
      isAuthenticated: !!token
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  var context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
}